import React from 'react'
import { AdminEditCategory } from '../../../../../Components/Views'

const Render = () => {
    return (
        <AdminEditCategory />
    )
}

export default Render